module.exports = __webpack_public_path__ + "img/partnership-agreement.4af36675.png";